/* eslint-disable-next-line no-restricted-imports */
import {
	EMBEDDED_CONFLUENCE_METRICS_PREFIX,
	EMBEDDED_IFRAME_CONTENT_INITIALIZED,
} from '@atlassian/embedded-confluence';

import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker';

import { subscribeToContentSize } from './subscribeToContentSize';
import { httpInterceptor } from './httpInterceptor';
import { subscribeToVisibleHeight } from './subscribeToVisibleHeight';

export function initialize() {
	httpInterceptor();
	subscribeToContentSize();
	subscribeToVisibleHeight();

	window.parent.postMessage(
		{
			type: EMBEDDED_CONFLUENCE_METRICS_PREFIX + EMBEDDED_IFRAME_CONTENT_INITIALIZED,
			payload: { timestamp: Date.now() },
		},
		'*',
	);

	window.addEventListener('unload', () => {
		// signal to EP parent that it is safe to run onUnload handler that may interfere with CCFE
		window.parent?.postMessage({ type: 'windowUnload' }, '*');
	});

	return Promise.all([
		import(
			/* webpackChunkName: "loadable-embedded-subscribeCrossDomainCommunication" */ '@atlassian/embedded-confluence/subscribeCrossDomainCommunication'
		),
		import(
			/* webpackChunkName: "loadable-embedded-crossDomainExperienceForwarding" */ '@atlassian/embedded-confluence/crossDomainExperienceForwarding'
		),
	]).then(([{ subscribeCrossDomainCommunication }, { crossDomainExperienceForwarding }]) => {
		subscribeCrossDomainCommunication();
		crossDomainExperienceForwarding(getExperienceTracker());
	});
}

export function initializeMobileApp() {
	subscribeToContentSize();
	subscribeToVisibleHeight();

	window.parent.postMessage(
		{
			// @TODO: Add a new event type for mobile app that isn't a magic string
			type: 'mobileAppContentInitialized',
			payload: { timestamp: Date.now() },
		},
		'*',
	);

	window.addEventListener('unload', () => {
		// signal to EP parent that it is safe to run onUnload handler that may interfere with CCFE
		window.parent?.postMessage({ type: 'windowUnload' }, '*');
	});

	return Promise.resolve(true);
}
